import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-623925c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Transferir", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = {
  key: 0,
  class: "ss-carregando-estoque"
}
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_22 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-14 ant-col-xl-14" }
const _hoisted_30 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_31 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_34 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = { key: 4 }
const _hoisted_41 = { key: 5 }
const _hoisted_42 = { key: 6 }
const _hoisted_43 = { key: 7 }
const _hoisted_44 = {
  key: 8,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 9 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_produto_detalhes = _resolveComponent("produto-detalhes")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 1260,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-estoques",
      title: "Transferência entre Estoques"
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.transferirEstoque()))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, {
                      label: "Código",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.codigo) = $event)),
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.state.codigo]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_a_form_item, {
                      label: "Data",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.dataTransferencia,
                          "onUpdate:dataSelecionada": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.dataTransferencia) = $event)),
                          horaMinutoSegundo: true,
                          disabled: true,
                          placeholder: ""
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_form_item, {
                      label: "Usuário",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_usuario, {
                          codigoSelecionado: _ctx.state.codigoUsuario,
                          "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigoUsuario) = $event)),
                          disabled: true,
                          empresas: _ctx.telaBase.empresasSelecionadas
                        }, null, 8, ["codigoSelecionado", "empresas"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "Produto",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("a", {
                          class: "ss-apresentar-superior-direito ss-fonte-negrito ss-botao-acima-campo",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.apresentarDetalhesProduto = true))
                        }, [
                          _createVNode(_component_icone, { nome: "informacoes-fp" }),
                          _createTextVNode(" Detalhes")
                        ], 512), [
                          [_vShow, _ctx.state.codigoProdutoDefinicao > 0]
                        ]),
                        _createVNode(_component_selecionar_produto, {
                          codigoSelecionado: _ctx.state.codigoProdutoDefinicao,
                          "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.codigoProdutoDefinicao) = $event)),
                          modoDefinicaoProduto: true,
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          apresentarCodigoInterno: true,
                          placeholder: 'Digite o código interno, código de barras, código personalizado ou descrição do produto...',
                          limparSelecao: false,
                          disabled: (_ctx.state.codigo > 0),
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.obterDadosIdentificacaoDefinicao($event)))
                        }, null, 8, ["codigoSelecionado", "empresas", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_form_item, {
                      label: "Unidade",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          value: _ctx.state.unidadeProduto.sigla +  ' - ' + _ctx.state.unidadeProduto.descricao,
                          readonly: ""
                        }, null, 8, _hoisted_10)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_card, {
                  class: "ss-padding-separacao-direita",
                  titulo: "ORIGEM"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.telaBase.empresasSelecionadas.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_a_form_item, {
                              label: "Empresa",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_empresa, {
                                  codigoSelecionado: _ctx.state.codigoEmpresaOrigem,
                                  "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.codigoEmpresaOrigem) = $event))
                                }, null, 8, ["codigoSelecionado"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_form_item, {
                          label: "Estoque",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_estoque, {
                              empresas: _ctx.telaBase.empresasSelecionadas,
                              codigoSelecionado: _ctx.state.codigoEstoqueOrigem,
                              "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.codigoEstoqueOrigem) = $event)),
                              ignorarEstoques: [_ctx.state.codigoEstoqueDestino],
                              onChange: _ctx.buscarInformacoesEstoqueOrigem
                            }, null, 8, ["empresas", "codigoSelecionado", "ignorarEstoques", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (_ctx.state.buscandoInformacoesEstoqueOrigem)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_a_spin, { size: "large" })
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_a_form_item, {
                          label: "Quantidade a transferir",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              valor: _ctx.state.qtdTotalSelecionada,
                              quantidadeCasasDecimais: _ctx.state.unidadeProduto.casasDecimais
                            }, null, 8, ["valor", "quantidadeCasasDecimais"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_a_form_item, {
                          label: "Quantidade Após transferência",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              valor: (_ctx.state.quantidadeAtualOrigem - _ctx.state.qtdTotalSelecionada),
                              permitirValorNegativo: true,
                              quantidadeCasasDecimais: _ctx.state.unidadeProduto.casasDecimais,
                              disabled: true
                            }, null, 8, ["valor", "quantidadeCasasDecimais"])
                          ]),
                          _: 1
                        })
                      ])
                    ], 512), [
                      [_vShow, (_ctx.state.codigoEstoqueItemOrigem > 0 && !_ctx.state.buscandoInformacoesEstoqueOrigem)]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_card, {
                  class: "ss-padding-separacao-esquerda",
                  titulo: "DESTINO"
                }, {
                  default: _withCtx(() => [
                    (_ctx.telaBase.empresasSelecionadas.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_a_form_item, {
                              label: "Empresa",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_empresa, {
                                  codigoSelecionado: _ctx.state.codigoEmpresaDestino,
                                  "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.codigoEmpresaDestino) = $event))
                                }, null, 8, ["codigoSelecionado"])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_a_form_item, {
                          label: "Estoque",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_estoque, {
                              empresas: _ctx.telaBase.empresasSelecionadas,
                              codigoSelecionado: _ctx.state.codigoEstoqueDestino,
                              "onUpdate:codigoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.codigoEstoqueDestino) = $event)),
                              ignorarEstoques: [_ctx.state.codigoEstoqueOrigem],
                              onChange: _ctx.buscarInformacoesEstoqueDestino
                            }, null, 8, ["empresas", "codigoSelecionado", "ignorarEstoques", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_a_form_item, {
                          label: "Quantidade Após transferência",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              valor: (_ctx.state.quantidadeAtualDestino + _ctx.state.qtdTotalSelecionada),
                              permitirValorNegativo: true,
                              quantidadeCasasDecimais: _ctx.state.unidadeProduto.casasDecimais,
                              disabled: true
                            }, null, 8, ["valor", "quantidadeCasasDecimais"])
                          ]),
                          _: 1
                        })
                      ])
                    ], 512), [
                      [_vShow, (_ctx.state.codigoEstoqueItemDestino > 0 && !_ctx.state.buscandoInformacoesEstoqueDestino)]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_card, { titulo: "LANÇAMENTO" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_a_form_item, {
                      label: "Identificador",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.identificadorSelecionado) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.identificadorSelecionado]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_a_form_item, {
                      label: "Quantidade",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          "quantidade-casas-decimais": _ctx.state.definicaoProduto.casasDecimais,
                          valor: _ctx.state.qtdSelecionada,
                          "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.qtdSelecionada) = $event))
                        }, null, 8, ["quantidade-casas-decimais", "valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          style: {"width":"100%"},
                          class: "ant-btn ant-btn-secondary",
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.adicionar && _ctx.adicionar(...args)))
                        }, _toDisplayString(_ctx.state.edicao ? 'Editar' : 'Adicionar'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            (_ctx.state.rastreabilidades.length > 0)
              ? (_openBlock(), _createBlock(_component_card, {
                  key: 0,
                  titulo: "RASTREABILIDADES",
                  class: "ss-padding-separacao-esquerda"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_a_form_item, {
                          label: "Filtrar",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                              onKeyup: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.filtrar && _ctx.filtrar(...args)))
                            }, null, 544), [
                              [_vModelText, _ctx.state.buscaRapida]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_a_table, {
                      columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                      "data-source": _ctx.state.rastreabilidades,
                      rowKey: "codigo",
                      pagination: false,
                      loading: _ctx.gradeBase.buscandoDados,
                      size: "small"
                    }, {
                      bodyCell: _withCtx(({ column, record, text, index }) => [
                        (column && column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              (record.qtdSelecionada > 0)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.editar(index, true))
                                  }, [
                                    _createVNode(_component_icone, { nome: "editar" })
                                  ], 8, _hoisted_35))
                                : _createCommentVNode("", true),
                              (record.qtdSelecionada <= 0)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.editar(index, false))
                                  }, [
                                    _createVNode(_component_icone, { nome: "mais" })
                                  ], 8, _hoisted_36))
                                : _createCommentVNode("", true)
                            ]))
                          : (column.key === 'Identificador' && record.qtdSelecionada === 0)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                onClick: ($event: any) => (_ctx.editar(index, false)),
                                style: {"color":"blue","cursor":"pointer"}
                              }, _toDisplayString(record.identificador), 9, _hoisted_37))
                            : (column.key === 'NumeroLote')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(record.numeroLote), 1))
                              : (column.key === 'DataValidade')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataValidade)), 1))
                                : (column.key === 'NumeroSerieArma')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(record.numeroSerieArma), 1))
                                  : (column.key === 'NumeroSerieCano')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(record.numeroSerieCano), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, _ctx.state.definicaoProduto.casasDecimais, false, true)), 1))
                                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(text)), 1))
                                        : (column.key === 'Rastreabilidade')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                              (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Nenhum)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.codigo), 1),
                                                    _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricaoEstoque), 1),
                                                    _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, _ctx.state.definicaoProduto.casasDecimais, false, true)), 1),
                                                    _createElementVNode("span", null, "Qtd Selecionada: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdSelecionada, _ctx.state.definicaoProduto.casasDecimais)), 1)
                                                  ], 64))
                                                : _createCommentVNode("", true),
                                              (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Outros)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                    _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                    _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                    _createElementVNode("span", null, "Qtd Selecionada: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdSelecionada, _ctx.state.definicaoProduto.casasDecimais)), 1)
                                                  ], 64))
                                                : _createCommentVNode("", true),
                                              (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Lote)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                    _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                    _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                    _createElementVNode("span", null, "Qtd Selecionada: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdSelecionada, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                    _createElementVNode("span", null, "Nº do Lote: " + _toDisplayString(record.numeroLote), 1),
                                                    _createElementVNode("span", null, "Vencimento: " + _toDisplayString(record.dataValidade), 1)
                                                  ], 64))
                                                : _createCommentVNode("", true),
                                              (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Armamento)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                    _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                    _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                    _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                    _createElementVNode("span", null, "Qtd Selecionada: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdSelecionada, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                    _createElementVNode("span", null, "Nº da Arma: " + _toDisplayString(record.numeroSerieArma), 1),
                                                    _createElementVNode("span", null, "Nº do Cano: " + _toDisplayString(record.numeroSerieCano), 1)
                                                  ], 64))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("a", {
                                                onClick: ($event: any) => (_ctx.editar(index, false))
                                              }, [
                                                _createVNode(_component_icone, { nome: "editar" })
                                              ], 8, _hoisted_45)
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(text), 1))
                      ]),
                      emptyText: _withCtx(() => [
                        _createVNode(_component_mensagem_sem_dados, {
                          resultadoPesquisa: true,
                          mensagem: "Nenhuma rastreabilidade lançada."
                        })
                      ]),
                      _: 1
                    }, 8, ["columns", "data-source", "loading"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_produto_detalhes, {
          codigoProdutoDefinicao: 1,
          visivel: _ctx.state.apresentarDetalhesProduto,
          "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.apresentarDetalhesProduto) = $event))
        }, null, 8, ["visivel"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}